import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Tab,Col,Nav,Row} from 'react-bootstrap';
import { format } from 'date-fns';
import {userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../../configs/urlConfigs';
import { MSG_VEHICLE_DETAILS_UPDATED_SUCCESS,MSG_VEHICLE_DETAILS_ADDED_SUCCESS,MSG_RECORDED_ADDED_SUCCESS,MSG_NOT_FOUND,MSG_NO_INPUT_PROVIDED,MSG_RECORDED_DELETE_SUCCESS,MSG_RECORDED_UPDATED_SUCCESS,MSG_DELETE_VECHICLE_DETAILS,MSG_DYNAMIC_FIELD_NAME_REQUIRED,MSG_DYNAMIC_FIELD_TYPE_REQUIRED} from '../../../configs/msgConfigs';
import { LBL_APPROVED,LBL_ACTIONS,LBL_EDIT,LBL_DELETE,LBL_EDIT_VEHICLE,LBL_ADD_VEHICLE,LBL_ADD_VEHICLE_FIELDS,LBL_VEHICLE_LIST,LBL_SAVE,LBL_BTN_ADDNEW,LBL_SLNUM,LBL_FIELD_NAME,LBL_FIELD_TYPE,LBL_CREW_VISIBILITY,LBL_CLIENT_VISIBILITY,LBL_MANDATORY_FIELD,LBL_SHO} from '../../../configs/labelConfigs';
import { TAB1,TAB2,DYNAMIC_FIELDS_TYPES,DELETE_SYMBOL} from '../../../configs/staticConfigs';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';
import { clearAction} from '../../../actions/commonActions';
import {format as stringFormat} from 'react-string-format';
import { converDateToLocal,convertDecimalToHHMM,convertHHMMToDecimal } from '../../../utils/commonUtilities';
import { listFieldDetails,saveFieldDetails,saveVehicleInfo,listVehicleInfo,deleteVehicleInfo,updateVehicleInfo,getVehicleInfo} from '../../../actions/settings/affiliates/vehicleInfoAction';
import { GET_VEHICLE_INFO_SUCCESS,LIST_FIELD_DETAILS_SUCCESS,SAVE_FIELD_DETAILS_SUCCESS,SAVE_VEHICLE_INFO_SUCCESS,LIST_VEHICLE_INFO_SUCCESS,UPDATE_VEHICLE_INFO_SUCCESS,DELETE_VEHICLE_INFO_SUCCESS} from '../../../actions'; 

class CrewVehicleInfo extends Component { 

    constructor(props){
        super(props)
        this.vehicleDetailsModal = React.createRef();
        let userGroupData = userGroupUrlCheck(window.location);
        let profileId = '';
        if(userGroupData!==undefined){
            profileId = userGroupData.profile_id;
        }
        let timeZone =  getUserTimeZone(window.location);
        this.state = {
            formErrors : {},
            infoFormErrors : {},
            commonErrMsg:'',
            valueErrMsg:'',
            fieldDetails:[],
            affiliate:parseInt(profileId),
            toastMessagePop:'',
            toastFlagPop:false,
            toastSuccessPop:true,
            vehicleDetailsHeader:LBL_ADD_VEHICLE,
            vehicleInfoDetailedList:[],
            vehicleInfoValue:{},
            activeRowId:0,
            deleteId:0,
            timeZone:timeZone,
            editId:0
        }
    }

    onCloseToastPop = () =>{ // USED FOR POPUP clientContactAdd
        this.setState({toastFlagPop:false,toastMessagePop:'',toastSuccessPop:false});
    } 

    setToasterStatePop = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlagPop:isEnabled,toastMessagePop:message,toastSuccessPop:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToastPop();
            }, 3000);
        }    
    }

    componentDidMount() {
        document.body.classList.add('body-affiliate');
        // this.props.listFieldDetails();
        this.props.listVehicleInfo(this.props.crewId);
    }

    componentDidUpdate(prevProps) {  
        let {vehicleInfoActivity,vehicleInfoStatus,fieldDetailsList,vehicleInfoList,vehicleInfoRetrieve} = this.props;
        if (vehicleInfoActivity && (vehicleInfoStatus !== prevProps.status || vehicleInfoActivity!==prevProps.activity)) {
            var arrResp = vehicleInfoActivity.split('~~'); 
            var actString = arrResp[0]; 
            if(actString===LIST_FIELD_DETAILS_SUCCESS) { 
                this.setInfoFormError();
                this.props.clearAction();
                let field_details = []
                let {formErrors} = this.state;

                fieldDetailsList.map((item,index)=>{
                    item.field_id = index;
                    field_details.push(item)
                })
                if(fieldDetailsList.length === 0){
                    formErrors.fieldEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED;
                    formErrors.fieldTypeEmpty = MSG_DYNAMIC_FIELD_NAME_REQUIRED;
                    field_details.push({ field_id:0, id:"", field_name:'', field_type: '', is_mandatory: false, crew_visibility:false,client_visibility:false,affiliate:this.state.affiliate}); 
                }
                this.setState({fieldDetails:field_details,formErrors:formErrors});
            }
            if(actString===SAVE_FIELD_DETAILS_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_RECORDED_ADDED_SUCCESS,true);
                //this.props.listFieldDetails();
            }
            if(actString===LIST_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                let vehicleInfoValue = {}
                if(vehicleInfoList.length>0){
                    
                    vehicleInfoList[0].affiliatevehicledetails_set.map((item,index)=>{
                        let value = '';
                        fieldDetailsList.map((fieldItem,fieldIndex)=>{
                            if(fieldItem.id === item.field_info){
                                if(fieldItem.field_type === 'string'){
                                    value = item.text_value;

                                }else{
                                     value = new Date(converDateToLocal(item.date_value,this.state.timeZone.utc_offset,'yyyymmdd'));
                                }
                            }
                            
                        })
                        
                        vehicleInfoValue[item.field_info]=value;
                        let {infoFormErrors} = this.state;
                        if(Object.keys(infoFormErrors).indexOf(item.field_info.toString()) !== -1){
                            if(value === '' | value === null){
                                infoFormErrors[item.field_info] = "input-error";
                            }else{
                                infoFormErrors[item.field_info] = "";
                            }
                        }
                    })
                    vehicleInfoValue['is_approved'] = vehicleInfoList[0].is_approved;
                    this.setState({vehicleInfoValue:vehicleInfoValue,editId:vehicleInfoList[0].id});
                }else{
                    this.setState({vehicleInfoValue:vehicleInfoValue,editId:0});
                }
                this.props.reloadParentCrewList();
            }
            if(actString===SAVE_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_VEHICLE_DETAILS_ADDED_SUCCESS,true);
                this.props.listVehicleInfo(this.props.crewId);
                this.props.reloadParentCrewList();
            }
            if(actString===UPDATE_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_VEHICLE_DETAILS_UPDATED_SUCCESS,true);
                this.props.listVehicleInfo(this.props.crewId);
                this.props.reloadParentCrewList();
            }
            if(actString===DELETE_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                this.setToasterStatePop(true,MSG_RECORDED_DELETE_SUCCESS,true);
                this.props.listVehicleInfo(this.props.crewId);
            }
            if(actString===GET_VEHICLE_INFO_SUCCESS) { 
                this.props.clearAction();
                let vehicleInfoValue = {}
                vehicleInfoRetrieve.affiliatevehicledetails_set.map((item,index)=>{
                    let value = '';
                    fieldDetailsList.map((fieldItem,fieldIndex)=>{
                        if(fieldItem.id === item.field_info){
                            if(fieldItem.field_type === 'string'){
                                value = item.text_value;

                            }else{
                                 value = new Date(converDateToLocal(item.date_value,this.state.timeZone.utc_offset,'yyyymmdd'));
                            }
                        }
                        
                    })
                    
                    vehicleInfoValue[item.field_info]=value;
                    let {infoFormErrors} = this.state;
                    if(Object.keys(infoFormErrors).indexOf(item.field_info.toString()) !== -1){
                        if(value === '' | value === null){
                            infoFormErrors[item.field_info] = "input-error";
                        }else{
                            infoFormErrors[item.field_info] = "";
                        }
                    }
                })
                this.setState({vehicleInfoValue:vehicleInfoValue})
            }
        }
        
    }

    onHandleVehicleInfoChange = (e,item,type) =>{
        let value = '';
        let {vehicleInfoValue,infoFormErrors} = this.state;
        if(type==='string'){
            value = e.target.value;
        }else{
            if(e === '' || e === null){
                value = new Date();
            }else{
                value = new Date(e);
            }
        }
        vehicleInfoValue[item.id] = value;
        if(Object.keys(infoFormErrors).indexOf(item.id.toString()) !== -1){
            if(value==="" || value === null){
                infoFormErrors[item.id] = "input-error";
            }else{
                infoFormErrors[item.id] = "";
            }

        }
        this.setState({vehicleInfoValue:vehicleInfoValue,infoFormErrors:infoFormErrors})
    }

    setInfoFormError = ()=>{
        let {infoFormErrors} = this.state;
        this.props.fieldDetailsList.map((item,index)=>{
            if(item.is_mandatory){
              infoFormErrors[item.id] = "input-error";  
            }
            
        })
        this.setState({infoFormErrors:infoFormErrors})
    }
    onSaveCrewVehicleFormData = (e) =>{
        let {vehicleInfoValue} = this.state;
        let {fieldDetailsList} = this.props;
        let flag = true;
        Object.values(vehicleInfoValue).map((item,index) =>{
            if(item !== "" || item !== null){
                flag = false;
            }
        });
        Object.values(this.state.infoFormErrors).map((item,index)=>{
            if(item === 'input-error'){
                flag = true;
            }
        })
        if(flag){
            this.setState({valueErrMsg:MSG_NO_INPUT_PROVIDED})
        }else{
            let vehicleSaveObj = [];
            fieldDetailsList.map((fieldItem,fieldIndex)=>{
                if(Object.keys(vehicleInfoValue).indexOf(fieldItem.id.toString()) !== -1){

                    let text_value = '';
                    let date_value = null;
                    if(fieldItem.field_type === 'string'){
                        text_value = vehicleInfoValue[fieldItem.id]
                    }else{
                        date_value = format(vehicleInfoValue[fieldItem.id],'yyyy-MM-dd')
                    }
                    vehicleSaveObj.push({"field_name":fieldItem.field_name,"text_value":text_value,
                                            "date_value":date_value,"field_info":fieldItem.id})
                }

            })
            if(this.state.editId!==0){
                this.props.vehicleInfoList[0].affiliatevehicledetails_set.map((item,index)=>{
                    vehicleSaveObj.map((vehItem,index)=>{
                        if(vehItem.field_info === item.field_info){
                            vehItem['id'] = item.id
                        }
                    })
                })
                this.props.updateVehicleInfo({id:this.state.editId,vehicle_details:vehicleSaveObj,is_approved:vehicleInfoValue.is_approved})
            }else{
                this.props.saveVehicleInfo({vehicle_details:vehicleSaveObj,crewId:this.props.crewId,is_approved:vehicleInfoValue.is_approved});
            }
        }


    }
    onModalFormReset = (e) =>{  
      // this.vehicleDetailsModal.current.handleCloseModal();       

    }
    
   editVehicleBtnClick = (e,id) =>{
        this.props.getVehicleInfo(id);
        this.setState({editId:id});
   }
   
   onHandleIsApprovedChange =(e)=>{
        let {vehicleInfoValue} = this.state;
        let checked = e.target.checked;
        vehicleInfoValue['is_approved'] = checked;
        this.setState({vehicleInfoValue:vehicleInfoValue})
   }
       
    render(){
        let {fieldDetails, toastMessagePop, toastSuccessPop, toastFlagPop} = this.state;
        let fieldId = '';
        let dtVal = '';
        let newDate = new Date();
        let timeZone =  getUserTimeZone(window.location);
        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrew = 'Staff'
        if(userGroupData!==undefined){
            if(userGroupData.staff_name){
                lblCrew = userGroupData.staff_name; 
            }
        }
        return(
                <React.Fragment>
                    <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToastPop} />

                    <div className="box">
                        <Row>
                            {this.props?.fieldDetailsList && Array.isArray(this.props.fieldDetailsList) && this.props.fieldDetailsList.map((item,index) => {  
                                fieldId = item.id; 
                                return(
                                    <Col md={6} key={index} className={item.field_type==='date'?'margin-bottom-20':''}>
                                        <div className="form-group">
                                            <label>{item.field_name}</label>
                                            <div className="input-input">
                                                <React.Fragment> 
                                                    { (item.field_type==='string') && 
                                                        <input type="text" name={"txt_fieldValue_"+fieldId} value={this.state.vehicleInfoValue[fieldId]?this.state.vehicleInfoValue[fieldId]:''} onChange={(e) => this.onHandleVehicleInfoChange(e,item,'string')}  className={this.state.infoFormErrors[fieldId]? this.state.infoFormErrors[fieldId]:'' }/>
                                                    }
                                                    
                                                    { (item.field_type==='date') && 
                                                        <DatePicker 
                                                            selected={this.state.vehicleInfoValue[fieldId]?this.state.vehicleInfoValue[fieldId]:newDate}
                                                            onChange={dateVal => this.onHandleVehicleInfoChange(dateVal,item,'date')}
                                                            
                                                            placeholderText="Select a Date"
                                                            className={this.state.infoFormErrors[fieldId]? this.state.infoFormErrors[fieldId]: ""} 
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            fixedHeight   
                                                            autoComplete="off"
                                                            dateFormat={'dd/MM/yyyy'}
                                                        /> 
                                                    }
                                                    
                                                </React.Fragment>
                                                
                                            </div>
                                        </div>
                                    </Col>)
                                } ) }
                                </Row>
                            <Row>
                                <Col md={6} >
                                {this.props.fieldDetailsList.length > 0 && 
                                    <div className="custom-checkbox">
                                        <input name={"chk_is_approved"} type="checkbox" id={"chk_is_approved"}  checked={this.state.vehicleInfoValue.is_approved} onChange={(e) => this.onHandleIsApprovedChange(e)} /> <label className="checkbox" htmlFor={"chk_is_approved"}></label> 
                                        <label className="labeltext" htmlFor="chk_is_approved">{LBL_APPROVED}</label>
                                    </div>
                                }
                                </Col>
                                <Col md={6} className="text-right">
                                {this.props.fieldDetailsList.length > 0 && 
                                    <button type="button" className="btn btn-primary" onClick={(e)=>this.onSaveCrewVehicleFormData(e)}>{LBL_SAVE}</button>
                                }
                                </Col>
                            </Row>

                        </div>
                </React.Fragment>
            
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fieldDetailsList:state.vehicleInfoData.fieldDetailsList,
        vehicleInfoList:state.vehicleInfoData.vehicleInfoList,
        vehicleInfoStatus:state.vehicleInfoData.vehicleInfoStatus,
        vehicleInfoActivity:state.vehicleInfoData.vehicleInfoActivity,
        fieldDetailsSavedList:state.vehicleInfoData.fieldDetailsSavedList,
        vehicleInfoRetrieve:state.vehicleInfoData.vehicleInfoRetrieve
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        listFieldDetails:listFieldDetails,
        saveFieldDetails:saveFieldDetails,
        saveVehicleInfo:saveVehicleInfo,
        listVehicleInfo:listVehicleInfo,
        deleteVehicleInfo:deleteVehicleInfo,
        updateVehicleInfo:updateVehicleInfo,
        getVehicleInfo:getVehicleInfo,
        clearAction:clearAction
    },dispatch);
} 
export default connect(mapStateToProps,mapDispatchToProps)(CrewVehicleInfo);
